export default "__VITE_ASSET__1be95f73__"